<template>
  <div class="animated fadeIn">
    <h4 class="page-title">History</h4>
    <hr >
    <b-row class="mb-3">
      <b-col>
        <select
          v-model="filter"
          class="form-control w-50"
          @change="loadLogs">
          <option
            v-for="(v, k) in dateRanges"
            :key="k"
            :value="k">{{ v }}</option>
        </select>
      </b-col>
    </b-row>
    <b-row v-show="!histories.length && !isFetching">
      <b-col>
        <b-alert
          variant="info"
          show>No cleaning history found.</b-alert>
      </b-col>
    </b-row>

    <div
      v-if="isFetching"
      style="margin: 0 auto; width: 10px;">
      <div class="loader-dark-blue medium mb-5 mt-5"/>
    </div>

    <b-row
      v-if="histories.length"
      class="mt-3 mb-3">
      <b-col>
        <HistoryItem :items="histories" />
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { helperService } from '@/services/'
import { HistoryItem } from '@/components/'

export default {
  name: 'CleanerLogs',
  components: {
    HistoryItem
  },
  data () {
    return {
      isFetching: false,
      alerts: {
        dataEmpty: false
      },
      dateRanges: {
        today: 'Today',
        weekly: 'This Week',
        monthly: 'This Month'
      },
      histories: [],
      filter: 'today'
    }
  },
  mounted () {
    this.loadLogs()
  },
  methods: {
    loadLogs () {
      this.histories = []
      this.isFetching = true
      helperService.getCleanerHistory(this.filter).then(
        resp => {
          this.histories = resp.histories
          this.isFetching = false
        }
      )
    }
  }
}
</script>
